import { Paragraph } from "@digdir/designsystemet-react";
import { useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import type { BestillingPageKey } from "@/features/bestillinger";
import { useBestillingNavigation } from "../hooks";

export function BestillingStepper() {
  const router = useRouterState();
  const nav = useBestillingNavigation(
    router.location.pathname as BestillingPageKey,
  );
  const { t } = useTranslation();
  return (
    <Paragraph className="space-y-8" data-size="md">
      {t("skjema.stepper", {
        steg: nav.currentStep,
        total: nav.totalSteps,
      })}
    </Paragraph>
  );
}
